module.exports = __webpack_public_path__ + "menu_bg.png?b479ea58ddb89da16d1711334d9e817a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_bg.png
// module id = 102
// module chunks = 0